export enum Namespace {
    System = 'system',
    Form = 'form',
    Report = 'report',
    Analytics = 'analytics'
}

export enum Action {
    Onload = 'onload',
    onStorage = 'onStorage',
    onChartSave = 'chartMetadata',
    onOuterJoinSave = 'outerJoinMap'
}

export enum StoreName {
    RecentItems = 'recentItems',
    Announcements = 'announcements',
    F9 = 'F9'
}

export type StoreProps = {
    nameSpace: Namespace;
    action: Action;
    storage: StoreName | string;
    lang?: string;
    hasWildcard?: boolean;
};

export const getStorageKey = (props: StoreProps) => {
    const {nameSpace, action, storage, lang, hasWildcard} = props;

    let key = `${nameSpace}/${action}/${storage}`;

    if (lang) key = `${key}/${lang}`;

    if (hasWildcard) key = `${key}/*`;

    return key;
};
